export default __webpack_public_path__ + "static/media/exit.05551b1a.svg";